module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/252.6606255f.png";